export default __webpack_public_path__ + "static/media/confuse-doge.37e41c9d.gif";